import { Autocomplete, Box, TextField, Tooltip } from "@mui/material";
import { WarningAmberOutlined } from "@mui/icons-material";

export default function ClipsAutoComplete({ clip, clips, onSelected }) {
  const { numberOfChannels, sampleRate } = clip;

  const unsuitableClipError = (option) => {
    const numChan = numberOfChannels === option.numberOfChannels;
    const sampRate = sampleRate === option.sampleRate;
    let error = "Clip is not suitable for the current GLIMPSE model: ";
    if (!numChan) {
      error += `Number of channels (${option.numberOfChannels}) does not match (${numberOfChannels}). `;
    }
    if (!sampRate) {
      error += `Sample rate (${option.sampleRate}) does not match (${sampleRate}). `;
    }
    return error;
  };

  return (
    <Autocomplete
      disablePortal
      onChange={(_event, newValue) => onSelected(newValue)}
      options={clips}
      getOptionDisabled={(option) =>
        option.numberOfChannels !== numberOfChannels ||
        option.sampleRate !== sampleRate
      }
      getOptionLabel={(p) => p.description}
      getOptionKey={(p) => p.id}
      sx={{ W: 1, marginTop: 2 }}
      renderInput={(params) => (
        <TextField label="Selected Clip Name" {...params} />
      )}
      renderOption={(props, option) => {
        const { key, ...restProps } = props;
        return (
          <Box
            component="li"
            sx={{
              "&[aria-disabled='true']": {
                pointerEvents: "inherit !important",
                cursor: "not-allowed !important",
              },
              "&[aria-disabled='true']:active": {
                pointerEvents: "none !important",
              },
            }}
            key={option.id}
            {...restProps}
          >
            {option.numberOfChannels !== numberOfChannels ||
            option.sampleRate !== sampleRate ? (
              <Tooltip
                title={unsuitableClipError(option)}
                placement="top-start"
              >
                <Box display="flex" alignItems="center" gap={0.5} width={1}>
                  <WarningAmberOutlined color="warning" fontSize="inherit" />
                  <span>{option.description}</span>
                </Box>
              </Tooltip>
            ) : (
              option.description
            )}
          </Box>
        );
      }}
    />
  );
}
